<template>
  <div>
    <div class="breadcrumb_wrap"
         :style="{ background: bgColor }">
      <div class="EC_width display_between">
        <ul class="set_breadcrumb">
          <li @click="crumbsJump()">
            <a href="javascript:void(0)">首页</a>
          </li>
          <li>
            <a href="javascript:void(0)"
               style="cursor: auto;">详情</a>
          </li>
        </ul>
      </div>
    </div>
    <!-- <breadcrumbPage :search-tag="false"></breadcrumbPage> -->
    <div class="display_flex EC_width"
         v-show="type ==1">
      <div class="left">
        <div class="leftMenu">
          <a href="javascript:void(0);"
             class="leftTitle">
            {{WebSiteNavigInfo.columnName}}
          </a>
        </div>
        <ul class="scUl"
            v-show="subMenuList.length>0">
          <li @click="tagvue(item)"
              v-for="(item,index) in subMenuList"
              :key="index">
            {{item.columnName}}
            <img src="https://files.sciconf.cn/pc-template/c3/images/arrow_sub.png"
                 alt=""
                 class="arrow_sub">
          </li>
        </ul>
      </div>
      <div class="right"
           style="min-height: 580px"
           id="chatBox-content-demo">
        <div class="title">
          {{WebSiteNavigInfo.columnName}}
        </div>
        <div v-if="subMenuList.length>0">
          <div v-html="contents">
          </div>
        </div>
        <div v-else>
          <div v-html="WebSiteNavigInfo.contents"></div>
          <!-- <component :is="tagstr"></component> -->
        </div>
      </div>
    </div>

    <div class="display_flex EC_width"
         v-show="type ==2">
      <div class="left">
        <div class="leftMenu">
          <a href="javascript:void(0);"
             class="leftTitle">
            {{nvg_name}}
          </a>
        </div>
      </div>
      <div class="right"
           style="min-height: 580px"
           id="chatBox-content-demo">
        <div class="title">
          {{c_name}}
        </div>
        <div>
          <div v-html="c_contents">
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
// import breadcrumbPage from "../home/breadcrumbPage"
export default {
  name: "meetingDetail",
  data () {
    return {
      mtgId: 0,
      ID: 0,
      cID: 0,
      WebSiteNavigInfo: {},
      subMenuList: [],
      contents: "",
      offsetHeight: "min-height: 500px",
      type: this.$route.query.type,
      c_contents: "",
      c_name: "",
      nvg_name: ""
    }
  },
  //   components: {
  //     breadcrumbPage,
  //   },
  methods: {
    tagvue (item) {
      this.contents = item.contents
    },
    GetWebSiteNavigByID () {
      let _this = this
      this.httphelper
        .post(
          '/api/WebSiteConfigApi/GetWebSiteNavigByID',
          {
            c_Id: parseInt(_this.ID),
            type: 1,
          }
        )
        .then((res) => {
          if (res.data.code == 200) {
            res.data.data.forEach((item) => {
              if (item.id == _this.ID) {
                _this.contents = item.contents
                _this.WebSiteNavigInfo = item
              } else {
                _this.subMenuList.push(item)
                _this.contents = _this.subMenuList[0].contents
              }
            })
          }
        })
    },
    GetWebSiteColumnDetailsByID () {
      let _this = this
      this.httphelper
        .post(
          '/api/WebSiteConfigApi/GetWebSiteColumnByID',
          {
            c_Id: parseInt(_this.cID),
            type: 1,
          }
        )
        .then((res) => {
          if (res.data.code == 200) {
            _this.nvg_name = res.data.data.columnName
            _this.c_contents = res.data.data.contents
            _this.c_name = res.data.data.columnName
          }
        })
      ///有信息管理的时候
      if (_this.ID != 0) {
        this.httphelper
          .post(
            '/api/WebSiteConfigApi/GetMtgWebSiteColumnDetailsList',
            {
              c_Id: parseInt(_this.cID),
              type: 1,
            }
          )
          .then((res) => {
            if (res.data.code == 200) {
              res.data.data.forEach((item) => {
                if (item.id == _this.ID) {
                  _this.c_contents = item.contents
                  _this.c_name = item.columnName
                }
              })
            }
          })
      }
    },
    // 判断是手机还是pc
    isMobile () {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },
    scrollToBottom: function () {
      this.offsetHeight = "min-height:" + (this.$el.querySelector("#chatBox-content-demo").offsetHeight - 300) + "px"

    },
    getMeetingInfo () {
      let _this = this
      this.httphelper.get('/api/MeetingApi/GetMeetingInfoByID?mtgId=' + parseInt(this.mtgId)).then(res => {
        if (res.code == 200) {
          let data = res.data;

          _this.$route.meta.title = data.mtg_Name
          _this.$router.replace({
            query: {
              mid: _this.mtgId,
              id: this.ID,
              cid: this.cID,
              type: this.type,
              temp: Date.now()
            }
          });
        }
      });
    },
    crumbsJump () {
      this.$router.push({
        path: '/meetingMobile',
        query: {
          mid: this.mtgId,
        },
      })
    }
  },
  created () {
    if (this.$route.query.id != '') {
      this.ID = this.$route.query.id
    }
    if (this.$route.query.cid != '') {
      this.cID = this.$route.query.cid
    }
    if (this.$route.query.mid != '') {
      this.mtgId = this.$route.query.mid
    }
    if (this.isMobile()) {
      this.$router.push({
        path: '/meetingMobile',
        query: {
          mid: this.mtgId,
        },
      })
    }
    //查询详情
    if (this.$route.query.type == 1) {
      this.GetWebSiteNavigByID();
    } else {
      this.GetWebSiteColumnDetailsByID();
    }
    this.getMeetingInfo();
  },
  mounted () {
    this.scrollToBottom();
  }
}
</script>
<style >
img {
    max-width: 100% ;
}
</style>
<style scoped>
.left {
    width: 268px;
}

.leftMenu {
    background-color: rgb(98, 104, 196);
    position: relative;
    border: 1px solid #eee;
    filter: grayscale(30%);
}

.leftTitle {
    display: block;
    padding: 47px 15px 45px 15px;
    position: relative;
    color: #fff;
    font-size: 24px;
    line-height: 34px;
    text-transform: uppercase;
    text-align: center;
    font-weight: bold;
    letter-spacing: 3px;
    margin: 0;
}

.scUl {
    background: #fff;
    border: 1px solid #eee;
    padding: 30px 20px;
    border-top: 0;
    list-style: none;
}

.scUl li {
    background-color: rgb(98, 104, 196);
    color: rgb(255, 255, 255);
    padding: 25px 45px 25px 20px;
    display: block;
    cursor: pointer;
    transition: all 0.3s;
    font-size: 16px;
    font-weight: 600;
    margin-top: 10px;
    text-align: left;
}

.arrow_sub {
    float: right;
    margin-top: 3px;
}
.right {
    flex: 1;
    margin-left: 20px;
    border: 1px solid #eee;
    background: #fff;
    position: relative;
    min-height: 265px;
    padding: 10px 30px;
}
.title {
    text-align: left;
    padding: 0 0 10px;
    border-bottom: 1px solid #eee;
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 20px;
}
.breadcrumb_wrap {
    min-width: 1300px;
    list-style: none;
    height: 40px;
    background: #f2f2f2;
    display: flex;
}
.set_breadcrumb li {
    display: inline-block;
    font-size: 12px;
    color: #0b8485;
}

.set_breadcrumb li ~ li:before {
    content: '>';
    margin-left: 4px;
    margin-right: 4px;
    color: #333;
}

.set_breadcrumb li a {
    display: inline-block;
    font-size: 12px;
    color: #333;
}
/* 
.arrowBttom {
    border-style: solid;
    border-width: 6px;
    border-color: #000f15 transparent transparent transparent;
    position: absolute;
    top: 12px;
    right: 0;
}

.arrowTop {
    border-style: solid;
    border-width: 6px;
    border-color: transparent transparent #ccc transparent;
    position: absolute;
    top: -12px;
    left: 32px;
}



.set_breadcrumb {
    list-style: none;
    line-height: 40px;
    height: 100%;
    padding: 0;
}



.breadcrumb_search input {
    width: 200px;
    height: 30px;
    box-sizing: border-box;
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px;
    outline: none;
    border: 1px solid #f2f2f2;
    padding-left: 10px;
}

.ArrIcon {
    display: inline-block;
    width: 50px;
    height: 30px;
    background: #0b8686;
    border-radius: 0 30px 30px 0;
    text-align: center;
    line-height: 34px;
    cursor: pointer;
    box-sizing: border-box;
}

.signWrap {
    padding: 0 18px;
    height: 30px;
    border: 1px solid #f2f2f2;
    border-right: none;
    box-sizing: border-box;
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px;
    background: #fff;
    text-align: center;
    line-height: 30px;
    position: relative;
    cursor: pointer;
}

.breadcrumb_search .signActive {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
}

.tipsWrap {
    width: 100px;
    list-style: none;
    margin: 0;
    padding: 0;
    background: #fff;
    border-radius: 4px;
    position: absolute;
    left: -10px;
    top: 40px;
    box-shadow: 0px 0px 3px #ccc;
}

.tipsli {
    height: 30px;
    text-align: center;
    cursor: pointer;
    line-height: 30px;
    position: relative;
}

.tipsli:hover {
    color: #0b8586;
}
.selectEl {
    width: 80px;
    height: 30px;
    box-sizing: border-box;
}
.selectClass {
    height: 30px !important;
    line-height: 30px !important;
} */
</style>
